<!--
    Summary:
        firstchoice.exhibition.web - mthfr-p6
    ChangeLog:
        wangn on 2020/12/6 added
-->
<template>
  <div class="v-mthfr-p6" title="mthfr-p6">
    <img-card class="card">
      <div slot="title" style="width:100%;">{{$t('Mthfr.P6_Title')}}</div>
      <!-- <p>{{$t('Mthfr.P6_Content')}}</p> -->
      <!-- <div class="table-wrapper"> -->
        
        <!-- <table id="cu-table">
          <thead></thead>
          <thead>
          <tr>
            <th>{{$t('Mthfr.P6_1_1')}}</th>
            <th>{{$t('Mthfr.P6_2_1')}}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{$t('Mthfr.P6_1_2')}}</td>
            <td>{{$t('Mthfr.P6_2_2')}}</td>
          </tr>
          <tr>
            <td>{{$t('Mthfr.P6_1_3')}}</td>
            <td>{{$t('Mthfr.P6_2_3')}}</td>
          </tr>
          </tbody>
        </table> -->
      <!-- </div> -->
       <div class="box" v-if="$i18n.locale=='zh-TCC'">
          <img src="../../../assets/images/mthfr/piechart_zh.png" >
        </div>
       <div class="box" v-if="$i18n.locale=='zh-CN'">
          <img src="../../../assets/images/mthfr/piechart_cn.png" >
        </div>
       <div class="box" v-if="$i18n.locale=='en-US'">
          <img src="../../../assets/images/mthfr/piechart_en.png" >
        </div>
    </img-card>
  </div>
</template>

<script>
  import ImgCard from "../img-card";

  export default {
    name: "mthfr-p6",
    components: {ImgCard}
  }
</script>

<style scoped lang="scss">
  .v-mthfr-p6 {

    .table-wrapper {
      margin-top: 30px;
    }
  }
    .box {
       
        display: flex;

        img {
          width: 100%;
          height: 100%;
        }
    }
</style>




// WEBPACK FOOTER //
// src/view/genedetection/mthfr/mthfr-p6.vue